import _eqProps from "ramda/es/eqProps";
import _has from "ramda/es/has";
import _reduce from "ramda/es/reduce";
import _curry from "ramda/es/curry";
export default _curry(function (props, a, b) {
  return _reduce(function (acc, k) {
    return acc && _has(k, a) && _has(k, b) && _eqProps(k, a, b);
  }, true, props);
});